import axios from 'axios';
import secureLocalStorage from 'react-secure-storage';

// Correct environment variable key
const BASE_URL = import.meta.env.VITE_API_BASE_URL || '';

const bearerVariable = 'Bearer';

// Create Axios instance
const API = axios.create({
  baseURL: BASE_URL,
});

// Request interceptor to include tokens in headers
API.interceptors.request.use(
  (config) => {
    const authToken = secureLocalStorage.getItem('authToken');
    if (authToken) {
      config.headers['Authorization'] = `${bearerVariable} ${authToken}`;
    }
    return config;
  },
  (error) => {
    console.error('Axios request error:', error);
    return Promise.reject(error);
  }
);

// Function to set auth token
export const setAuthToken = (newAuthToken, newRefreshToken) => {
  if (newAuthToken) {
    secureLocalStorage.setItem('authToken', newAuthToken);
    secureLocalStorage.setItem('refreshToken', newRefreshToken);
    API.defaults.headers.common['Authorization'] = `${bearerVariable} ${newAuthToken}`;
  } else {
    secureLocalStorage.removeItem('authToken');
    secureLocalStorage.removeItem('refreshToken');
    delete API.defaults.headers.common['Authorization'];
  }
};

// Function to refresh auth token
const refreshAuthToken = async () => {
  try {
    const refreshToken = secureLocalStorage.getItem('refreshToken');
    if (!refreshToken) {
      throw new Error('No refresh token available');
    }

    // Use a separate axios instance to prevent infinite loop
    const response = await axios.post(`${BASE_URL}/general/login/newAuthToken`, {
      refreshToken: refreshToken,
      deviceName: 'chrome',
    });

    const { auth_token: newAuthToken, refresh_token: newRefreshToken } = response.data;

    setAuthToken(newAuthToken, newRefreshToken);

    return newAuthToken;
  } catch (error) {
    console.error('Error refreshing token:', error);
    handleLogoutFn();
    throw error;
  }
};
const BASE_URL_AUTH = import.meta.env.VITE_BASE_URL || '/';

// Function to handle logout
export const handleLogoutFn = () => {
  secureLocalStorage.clear();
  
  if (!window.location.pathname.includes('auth/login') && !window.location.pathname.includes('register')&& !window.location.pathname.includes('auth/')&&!window.location.pathname.startsWith(`${BASE_URL_AUTH}payments/`)) {
    window.location.href = `${BASE_URL_AUTH}auth/login`; // Updated redirect path
  }
};

// Response interceptor to handle token refresh
API.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        const newAuthToken = await refreshAuthToken();
        originalRequest.headers['Authorization'] = `${bearerVariable} ${newAuthToken}`;
        return API(originalRequest);
      } catch (err) {
        return Promise.reject(err);
      }
    }

    return Promise.reject(error);
  }
);

// API utility functions
export const fget = async ({ url, params }) => {
  return await API.get(url, { params });
};

export const fpost = async ({ url, data }) => {
  return await API.post(url, data);
};
export const fput = async ({ url, data }) => {
  return await API.put(url, data);
};
export const fdelete = async ({ url, params }) => {
  return await API.delete(url, { params });
};
export const fDownload = async ({ url }) => {
  return await API.get(url, { responseType: 'blob' });
};

export default API;